class GoogleTagManagerObject {
    cookieConsent = false;
    dead = false;

    addMetaData = ( dataObj ) => {}
    firePageView = () => {}
    fireLogin = () => {}
    firePurchaseClick = () => {}
    track = () => {}
    kill = () => {}
}

export const GoogleTagManager = new GoogleTagManagerObject();
